import { render, staticRenderFns } from "./RegisterOrganizationUsers.vue?vue&type=template&id=28d8f1ce"
import script from "./RegisterOrganizationUsers.vue?vue&type=script&lang=js"
export * from "./RegisterOrganizationUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports